<!-- eslint-disable -->
<template lang="pug">
    .drop-box(v-if="chain.length || gameStarted")
        .link-container(v-if="gameMode === 'inTurn' && !gameStarted")
            img(v-if="linksType === 'image'", class="chain-link_in-turn", :src="itemValue | apiFile")
            div.chain-link__text-container(
                v-else
                :class="{'chain-link__text-container_in-turn': gameMode === 'inTurn'}"
            )
                | {{ itemValue }}
        .chain-container(
            v-if="gameMode !== 'inTurn' || gameStarted"
            @wheel='handleScrollOfBox'
        )
            .link(
                v-for="(item, index) in chain",
                :key='index'
            )
                drag.chain-container__drag(
                    v-if="displayDragArea(item)"
                    :draggable="gameStarted && item.type !== 'correct-link'"
                    :transfer-data="{ item: item, index: index, from: 'chain' }"
                    @dragstart="$emit('dragStarted')"
                    @dragend="$emit('dragEnded')"
                )
                    img.chain-link(
                        :class="imageClass(item)",
                        :src='item.value | apiFile',
                        :data-index='index'
                        :draggable="gameStarted && item.type !== 'correct-link'"
                    )
                drop.drop-zone(
                    v-if="item.type === 'dropZone'",
                    @drop='dropItemInChain(item, $event)'
                )
                    .drop-zone__shake-zone
                div.chain-link__text-container(
                    v-if="displayTextArea(item)",
                    :class="textAreaClass",
                )
                    div.chain-link__text-container__value {{ item.value }}
                div.chain-link__input-container(
                    v-if="item.type === 'textInput'",
                    class="chain__input-container_white"
                )
                    textarea.chain-link__text-input(
                        ref="input",
                        @focus="focusInput"
                        @keyup.enter="focusNextElement(index+1)",
                        v-model="item.value",
                        :disabled="item.type === 'correct-link'",
                        :placeholder="$i18n.t('trainer.trainer_gamePlayBox_answer')",
                    )
                svg.link-icon(
                    v-if="index !== chain.length - 1",
                    viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"
                )
                    path(d="M3.5789 22.0002C3.5789 25.6349 6.53594 28.592 10.1707 28.592L16.792 28.592C18.895 28.592 20.8282 27.5975 22.0558 25.9665C23.2834 27.5975 25.2167 28.592 27.3197 28.592L33.9614 28.592C37.5961 28.592 40.5532 25.6349 40.5532 22.0002C40.5532 18.3654 37.5961 15.4084 33.9614 15.4084L27.3197 15.4084C25.2143 15.4084 23.2828 16.4018 22.0559 18.0329C20.8289 16.4018 18.8974 15.4083 16.7921 15.4084L10.1708 15.4084C6.53594 15.4084 3.5789 18.3654 3.5789 22.0002ZM27.3197 17.1662L33.9614 17.1662C36.6269 17.1662 38.7954 19.3347 38.7954 22.0002C38.7954 24.6657 36.6269 26.8342 33.9614 26.8342L27.3197 26.8342C25.8513 26.8342 24.4954 26.1728 23.5916 25.0763L33.9608 25.0764C35.657 25.0764 37.037 23.6964 37.037 22.0002C37.037 20.3039 35.6571 18.924 33.9608 18.924L23.5907 18.924C24.4939 17.8272 25.8492 17.1662 27.3197 17.1662ZM31.2945 22.0002C31.2945 21.5286 31.1876 21.0816 30.9971 20.6818L33.9608 20.6818C34.6878 20.6818 35.2792 21.2732 35.2792 22.0002C35.2792 22.7271 34.6878 23.3185 33.9608 23.3185L30.9972 23.3185C31.1876 22.9187 31.2945 22.4718 31.2945 22.0002ZM28.2184 20.6818C28.9453 20.6818 29.5367 21.2732 29.5367 22.0002C29.5367 22.7271 28.9454 23.3185 28.2184 23.3185L15.9136 23.3185C15.1867 23.3185 14.5953 22.7271 14.5953 22.0002C14.5953 21.2732 15.1867 20.6818 15.9137 20.6818L28.2184 20.6818ZM13.1349 23.3185L10.1712 23.3185C9.44427 23.3185 8.85287 22.7271 8.85287 22.0002C8.85286 21.2732 9.44427 20.6818 10.1712 20.6818L13.1349 20.6818C12.9445 21.0817 12.8375 21.5286 12.8376 22.0002C12.8376 22.4718 12.9445 22.9187 13.1349 23.3185ZM10.1707 17.1662L16.792 17.1662C18.2625 17.1662 19.6177 17.8271 20.521 18.924L10.1713 18.924C8.47505 18.924 7.09507 20.3039 7.09507 22.0002C7.09507 23.6964 8.475 25.0763 10.1712 25.0763L20.5201 25.0763C19.6163 26.1728 18.2604 26.8341 16.7921 26.8341L10.1707 26.8341C7.50525 26.8341 5.33673 24.6656 5.33674 22.0001C5.33669 19.3347 7.5052 17.1662 10.1707 17.1662Z" fill="#2187FF")

</template>

<script>
    /*eslint-disable*/
    import { Drag, Drop } from 'vue-drag-drop';
    const DEFAULT_VOLUME = 0.6;

    export default {
        props: {
            chain: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            gameStarted: Boolean,
            gameMode: String,
            memorized: Boolean,
            linksType: String,
            dragStarted: Boolean,
            helperModeOn: Boolean,
        },
        data () {
            return {
                showingIndex: 0,
                soundInstance: null,
                isInputFocused: false,
            }
        },
        watch: {
            memorized () {
                if (this.gameMode === 'inTurn') {
                    if (this.showingIndex === this.chain.length - 2) {
                        this.$emit('displayPlayButton')
                    }
                    this.showingIndex++;
                }
            },
            gameStarted (value) {
                value && (this.$nextTick(this.scrollToBeginning));
            },
            dragStarted (value) {
                let shakeZone = document.querySelectorAll('.drop-zone__shake-zone');
                let amount = shakeZone.length;
                let timeouts = [];
                if (value && shakeZone) {
                    for (let i = 0; i < amount; i++) {
                        timeouts.push(setTimeout(() => {
                            shakeZone[i].classList.add('shake');
                        }, i * 100));
                    }
                    setTimeout(() => {
                        for(let j = 0; j < timeouts.length; j++) {
                            clearTimeout(timeouts[j]);
                        }
                        for (let i = 0; i < amount; i++) {
                            if (shakeZone[i]) {
                                shakeZone[i].classList.remove('shake');
                            }
                        }
                    }, 2000)
                }
            }
        },
        updated () {
            this.isInputFocused = this.helperModeOn === true ? false : this.isInputFocused;
            if (!this.isInputFocused && this.$refs.input && this.$refs.input[0]) {
                this.$refs.input[0].blur();
                this.focusNextElement();
            }
        },
        methods: {
            handleScrollOfBox (e) {
                e = window.event || e;
                let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
                let className = '.chain-container';
                document.querySelector(className).scrollLeft -= (delta * 65);
                e.preventDefault();
            },
            focusInput (event) {
                this.isInputFocused = this.$refs.input.some(element => _.isEqual(element, event.target));
            },
            scrollToBeginning () {
                document.querySelector('.chain-container').scrollLeft = 0;
            },
            dropItemInChain (link, data) {
                if (data && (data.from === 'answers-box' || data.from === 'chain')) {
                    this.soundInstance = this.$createjs.Sound.play("chainsDrop");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                    if (data.from === 'answers-box') {
                        this.$set(this.chain, this.chain.indexOf(link), _.cloneDeep(data.item));
                        this.$emit('dropItemInChain', data.index);
                    } else {
                        this.$set(this.chain, this.chain.indexOf(link), _.cloneDeep(data.item));
                        this.$set(this.chain, this.chain.indexOf(data.item), {type: 'dropZone'});
                    }
                }
            },
            focusNextElement(index = 0) {
                let uncompletedItems = this.chain.filter(item => item.type === "textInput");
                let completedItems = this.chain.filter((item, itemIndex) => item.type !== "textInput" && itemIndex < index);
                index = index - completedItems.length;
                index = index >= uncompletedItems.length ? index % uncompletedItems.length : index;
                let isChainCompleted = !this.chain.some(item => item.value === '');
                if (isChainCompleted) {
                    this.isInputFocused = false;
                    this.$emit('processReply');
                } else if (this.$refs.input[index]) {
                    this.$refs.input[index].focus();
                }
            },
            displayDragArea (item) {
                return this.linksType === 'image'
                        && (item.type !== 'dropZone' || item.type === 'correct-link')
            },
            displayTextArea (item) {
                return (this.linksType === 'word' || this.linksType === 'phrase')
                        && (item.type !== 'textInput' || item.type === 'correct-link')
            },
            imageClass (item) {
                return {
                    'chain-link_correct': item.type === 'correct-link'
                }
            },
            textAreaClass (item) {
                return {
                    'chain-link_correct': item.type === 'correct-link',
                    'chain-link_tipped': item.helpMarker
                }
            }
        },
        computed: {
            itemValue () {
                return this.chain[this.showingIndex].value;
            },
            customIconSizes () {
                const windowWidth = window.innerWidth;
                if (windowWidth < 576) {
                    return  {height: '19px', width: '12px'};
                } else if (windowWidth < 992) {
                    return  {height: '26px', width: '16px'};
                }
                return  {height: '32px', width: '20px'};
            },
        },
        components: {
            Drag,
            Drop
        }
    }
</script>

<style lang="scss" scoped>
   .link {
       display: inline-flex;
   }

    .link-icon {
        width: 25px;
        @include media ($md) {
            width: 50px;
        }
    }

    .link-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .drop-box {
        position: relative;
        display: inline-block;
        max-width: 100%;
    }

    .drop-box__shadow {
        top: 1px;
        display: flex;
        position: absolute;
        z-index: 100;
        height: calc(100% - 5px);
        align-items: center;
    }

    .drop-box__shadow_right {
        right: 0;
        padding-right: 15px;
        justify-content: flex-end;
        background: linear-gradient(to right, transparent, white);
        border-radius: 0 $border-radius-10 $border-radius-10 0;
        @include media ($md) {
            padding-right: 30px;
        }
    }

    .drop-box__shadow_left {
        left: 0;
        padding-left: 15px;
        justify-content: flex-start;
        background: linear-gradient(to left, transparent, white);
        border-radius: 0 $border-radius-10 $border-radius-10 0;
        @include media ($md) {
            padding-left: 30px;
        }
    }

    .drop-box__arrow-icon {
        color: $hsl-color-blue-56;
    }

    .drop-zone {
        display: inline-flex;
    }

    .drop-zone__shake-zone {
        width: 400px;
        height: 400px;
        margin: auto;
        background: white;
        border: 2px solid #E6E6F8;
        border-radius: 12px;
        @media screen and (max-width: 575px) {
            width: 100px;
            height: 100px;
        }
        @include media ($sm) {
            max-height: 120px;
            max-width: 120px;
        }
        @include media ($md) {
            max-height: 140px;
            max-width: 140px;
        }
        @include media ($lg) {
            max-height: 180px;
            max-width: 180px;
        }
        @include media ($xl) {
            max-height: 200px;
            max-width: 200px;
        }
        @include media ($xxl) {
            max-height: 320px;
            max-width: 320px;
        }
    }

    .chain-container {
        border-left: none;
        border-right: none;
        padding: 20px 0;
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
        user-select: none;
        //min-height: 255px;
        text-align: center;
        &::-webkit-scrollbar-track {
            background: #E6E6F8;
        }
        &::-webkit-scrollbar {
            background-color: #F5F5F5;
            height: 4px;
            @include media ($xxl) {
                height: 6px;
            }
        }
        &::-webkit-scrollbar-thumb {
            height: 4px;
            background: #c1c1f2;
            @include media ($xxl) {
                height: 6px;
            }
        }
    }

    .chain-container__drag {
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .chain-link {
        max-height: 100px;
        max-width: 100px;
        @include media ($sm) {
            max-height: 120px;
            max-width: 120px;
        }
        @include media ($md) {
            max-height: 140px;
            max-width: 140px;
        }
        @include media ($lg) {
            max-height: 180px;
            max-width: 180px;
        }
        @include media ($xl) {
            max-height: 200px;
            max-width: 200px;
        }
        @include media ($xxl) {
            max-height: 320px;
            max-width: 320px;
        }
    }

    .chain-link {
        display: inline-block;
        vertical-align: middle;
        border: 2px solid #E6E6F8;
        border-radius: 12px;
        margin-left: 20px;
        cursor: grab;
    }

    .chain-link__text-container, .chain-link__input-container {
        margin: auto;
        background: white;
        border: 1px solid $hsl-color-green-58;
        border-radius: 12px;
        text-align: center;
        font-size: 14px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        input {
            outline: none;
        }
        @include media ($sm) {
            font-size: 18px;
        }
        @include media ($lg) {
            font-size: 28px;
        }
        @include media ($xlg) {
            font-size: 30px;
        }
        @include media ($xl) {
            font-size: 42px;
        }
        @include media ($xxl) {
            font-size: 60px;
        }
        width: 100px;
        height: 100px;
        @include media ($sm) {
            width: 126px;
            height: 126px;
        }
        @include media ($md) {
            width: 160px;
            height: 160px;
        }
        @include media ($lg) {
            width: 210px;
            height: 210px;
        }
        @include media ($xl) {
            width: 300px;
            height: 300px;
        }
        @include media ($xxl) {
            width: 420px;
            height: 420px;
        }
    }

    .chain-link__text-container {
        font-weight: 500;
    }

    .chain-link__input-container {

    }

    .chain-link__text-container_in-turn {
        font-size: 34px;
        width: 250px;
        height: 250px;
        @include media ($sm) {
            font-size: 48px;
            width: 320px;
            height: 320px;
        }
        @include media ($lg) {
            font-size: 60px;
            width: 420px;
            height: 420px;
        }
    }

    .chain-link__text-container__value {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 10px;
        overflow-wrap: break-word;
        white-space: normal;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .chain-link__text-input {
        box-sizing: border-box;
        outline: none;
        resize: none;
        overflow: hidden;
        border-radius: 0;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        background: transparent;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-top: 40%;
        overflow-wrap: break-word;
        white-space: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        @include media ($sm) {
            font-size: 22px;
        }
        @include media ($lg) {
            font-size: 32px;
        }
        @include media ($xlg) {
            font-size: 42px;
        }
        @include media ($xxl) {
            font-size: 54px;
        }
        &::placeholder {
            font-size: 22px;
            font-weight: normal;
            @include media ($md) {
                font-size: 26px;
            }
            @include media ($lg) {
                font-size: 32px;
            }
            border-bottom: 1px solid $color-grey-300;
            opacity: .5;
        }
    }

    .chain-link {
        margin-left: 0;
    }

    .chain-link_correct {
        border: 3px solid $hsl-color-green-58;
    }

    .chain-link_tipped {
        border: 2px solid #ffc70f;
    }

    .chain-link_in-turn {
        width: 240px;
        height: 240px;
        border: 2px solid #E6E6F8;
        border-radius: 12px;
        @include media ($sm) {
            width: 280px;
            height: 280px;
        }
        @include media ($lg) {
            width: 400px;
            height: 400px;
        }
        @include media ($xlg) {
            width: 280px;
            height: 280px;
        }
        @include media ($xxl) {
            width: 420px;
            height: 420px;
        }
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
